import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, of } from 'rxjs';

import { Auth } from '../services/auth';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return of(router.createUrlTree(['/login']));
  }

  return auth.hasRoleSession('admin').pipe(
    map((isAdmin) => (isAdmin ? true : router.createUrlTree(['/dashboard']))),
  );
};
